import Mesh from "mediamonks-webgl/renderer/mesh/Mesh";
import Renderer from "mediamonks-webgl/renderer/render/Renderer";

export default class Cylinder extends Mesh {
  constructor(renderer: Renderer, segmentsX: number = 32, segmentsY: number = 1, radius: number = 1, height: number = 1, open: boolean = false, saveData: boolean = false) {
    super(renderer);

    let vertexCount: number = (segmentsX + 1) * (segmentsY + 1);
    if (!open) {
      vertexCount += ((segmentsX + 1) + 1) * 2;
    }

    const positionData: Float32Array = new Float32Array(vertexCount * 3);
    const uvData: Float32Array = new Float32Array(vertexCount * 2);
    const normalsData: Float32Array = new Float32Array(vertexCount * 3);

    let i: number = 0;
    let iUV: number = 0;
    let iNormal: number = 0;

    for (let y: number = 0; y < segmentsY + 1; y++) {
      const phaseY: number = (y / segmentsY);
      for (let x: number = 0; x < segmentsX + 1; x++) {
        const phaseX: number = x / segmentsX;
        positionData[i++] = Math.sin(phaseX * Math.PI * 2) * radius;
        positionData[i++] = (phaseY * 2 - 1) * height;
        positionData[i++] = Math.cos(phaseX * Math.PI * 2) * radius;

        uvData[iUV++] = phaseX;
        uvData[iUV++] = phaseY;

        normalsData[iNormal++] = Math.sin(phaseX * Math.PI * 2);
        normalsData[iNormal++] = 0;
        normalsData[iNormal++] = Math.cos(phaseX * Math.PI * 2);
      }
    }

    if (!open) {
      for (let y: number = 0; y < 2; y++) {
        positionData[i++] = 0;
        positionData[i++] = (y * 2 - 1) * height;
        positionData[i++] = 0;

        uvData[iUV++] = .5;
        uvData[iUV++] = .5;

        normalsData[iNormal++] = 0;
        normalsData[iNormal++] = (y * 2 - 1);
        normalsData[iNormal++] = 0;

        for (let x: number = 0; x < segmentsX + 1; x++) {
          const phaseX: number = x / segmentsX;
          positionData[i++] = Math.sin(phaseX * Math.PI * 2) * radius;
          positionData[i++] = (y * 2 - 1) * height;
          positionData[i++] = Math.cos(phaseX * Math.PI * 2) * radius;

          uvData[iUV++] = Math.sin(phaseX * Math.PI * 2) * .5 + .5;
          uvData[iUV++] = Math.cos(phaseX * Math.PI * 2) * .5 + .5;

          normalsData[iNormal++] = 0;
          normalsData[iNormal++] = (y * 2 - 1);
          normalsData[iNormal++] = 0;
        }
      }
    }

    this.setPositions(positionData, saveData);
    this.setUV0(uvData, saveData);
    this.setNormals(normalsData, saveData);

    let triCount: number = segmentsX * segmentsY * 2;
    if (!open) {
      triCount += segmentsX * 2;
    }

    const indices: Uint16Array = new Uint16Array(triCount * 3);
    const w: number = segmentsX + 1;

    i = 0;
    for (let y: number = 0; y < segmentsY; y++) {
      for (let x: number = 0; x < segmentsX; x++) {
        indices[i++] = (y * w) + x;
        indices[i++] = (y * w) + x + 1;
        indices[i++] = ((y + 1) * w) + x;

        indices[i++] = ((y + 1) * w) + x;
        indices[i++] = (y * w) + x + 1;
        indices[i++] = ((y + 1) * w) + x + 1;
      }
    }

    if (!open) {
      let offset = (segmentsX + 1) * (segmentsY + 1) + 1;
      for (let x: number = 0; x < segmentsX; x++) {
        indices[i++] = x + 2 + offset;
        indices[i++] = x + 1 + offset;
        indices[i++] = offset;
      }
      offset = (segmentsX + 1) * (segmentsY + 1) + 1 + (segmentsX + 1);
      for (let x: number = 0; x < segmentsX; x++) {
        indices[i++] = x + 1 + offset;
        indices[i++] = x + 2 + offset;
        indices[i++] = offset;
      }
    }

    this.setIndices(indices);
  }
}
